import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import HtmlInNewWindow from '../utils/HtmlInNewWindow'; // Import the new component
import UserNameContext from '../UserNameContext';
import EnvContext from "../envContext";
import configData from '../sso_config.json';
import { useMsal } from "@azure/msal-react";
import { functionAppLoginRequest } from "../msalConfig";

function SetRecoveryPhone() {
        const [textBox1, setTextBox1] = useState('');
        const [textBox2, setTextBox2] = useState('');
        const [textBox3, setTextBox3] = useState('');
        const [error, setError] = useState('');
        const [responseHtml, setResponseHtml] = useState(null); // State to store the response HTML
        const [isSubmitted, setIsSubmitted] = useState(false); // State to track if the form was submitted
        const [loading, setLoading] = useState(false); // State to track loading status
        const navigate = useNavigate();

        const { instance, accounts } = useMsal();

        // Pass username to Azure function
        const userName = useContext(UserNameContext);
        console.log("userName",userName); 

        const env = useContext(EnvContext);
        console.log("ENV", env);
        const [textBox4, setTextBox4] = useState(env);

      let endpointUrl = '';
      // API endpoint URL
      if(process.env.REACT_APP_RUN_ENV === 'local') {
          //endpointUrl = 'http://localhost:7071/api/reset_recovery_phone'; 
          endpointUrl = configData.LOCAL_API_URL + "reset_recovery_phone"; // Use the local API URL from the config file
      } else if (process.env.REACT_APP_RUN_ENV === 'qe') {
          //endpointUrl = 'https://xiosupporttool.azurewebsites.net/api/reset_recovery_phone';
          endpointUrl = configData.QE_API_URL + "reset_recovery_phone"; // Use the QE API URL from the config file
      } else {
          //endpointUrl = 'https://prd-use-atsgtool-func.azurewebsites.net/api/reset_recovery_phone';
          endpointUrl = configData.PROD_API_URL + "reset_recovery_phone"; // Use the production API URL from the config file
      }
      console.log("endpoint url",endpointUrl);
      const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate input and check if all required fields are filled
      if (!textBox1 || !textBox2) {    
        alert('Please enter mandatory fields, UserId and Recovery phone.');
        console.log('Please enter mandatory fields.');
        return;
      }
        setLoading(true); // Set loading to true before making the API call
        setIsSubmitted(false); // Reset the submission state

        // Rest request body contents
        const data = {
          userid: textBox1.trim(),
          recoveryPhone: textBox2.trim(),
          env: textBox4.trim(),
          userName: userName
        // email: textBox3
        };

        try {
          // 1. Acquire token
          const account = accounts[0];
          const tokenResponse = await instance.acquireTokenSilent({
                    ...functionAppLoginRequest,
                    account: account
          });
          const token = tokenResponse.accessToken;
          const response = await fetch(endpointUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
          });

          if (response.ok) {
            const data = await response.text();
            console.log('Success:', data);
            setResponseHtml(data);
            setIsSubmitted(true); // Mark the form as submitted
            //alert('Recovery phone set successfully: ' + JSON.stringify(result));
          } else {
            alert('Failed to set recovery phone: ' + response.statusText);
          }
        } catch (error) {
          alert('Error: ' + error.message);
        } finally {
            setLoading(false); // Set loading to false after the API call is complete
          }
      };

      const handleClear = () => {
        setTextBox1('');
        setTextBox2('');
        setTextBox3('');
        setTextBox4('PRD');
        setError('');
        setIsSubmitted(false); // Reset the submission state
      };

      const handleFieldChange = (setter) => (e) => {
        setter(e.target.value);
        setIsSubmitted(false); // Reset the submission state when any field changes
      };

      const goBack = () => {
        navigate(-1); // Navigate to the previous page
      };

      const goToHome = () => {
        navigate('/atsg/home'); // Navigate to the ATSG home page
      };

  return (
    <div className='menu-box shadow-xl shadow-cyan-500/30'>
      <div className='menu-title underline underline-offset-2'>
        <h2>Set Recovery Phone</h2>
      </div>
        <form onSubmit={handleSubmit}>
          <div className='text-box-title'>
            <label>User ID [Mandatory]</label>
            <input
              type="text"
              value={textBox1}
              onChange={handleFieldChange(setTextBox1)}
              title="Enter the User ID for which you want to set the recovery phone."
              style={{  width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            />
          </div>
          <div className='text-box-title'>
            <label>Recovery Phone Number [Mandatory]</label>
            <input
              type="text"
              value={textBox2}
              title="Enter the recovery phone number in format +1<area code><phone number>, for example +11234567890"
              onChange={handleFieldChange(setTextBox2)}
              style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            />
          </div>
        {/*
          <div className='text-box-title'>
            <label>Notify Email Address</label>
            <input
              type="email"
              value={textBox3}
              title="Enter a valid Crestron email address to receive notifications."
              onChange={handleFieldChange(setTextBox3)}
              style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            />
          </div>
          */}
          <div className='text-box-title'>
            <label>Environment:</label>
            <input
              type="Environment"
              value={textBox4}
              title="Enter the environment (e.g., PRD, HQE, etc.)."
              onChange={handleFieldChange(setTextBox4)}
              style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            readOnly />
          </div>
          {error && <p style={{ color: 'red', marginBottom: '15px' }}>{error}</p>}
          <div className='foot-box'>
            <button
              type="button"
              onClick={goBack} className='foot-button'
            >
              Back
            </button>
            <button
              type="submit" className='foot-button'
            >
              Submit
            </button>
            <button 
              type="button"
              onClick={handleClear} className='foot-button'>
              Clear
            </button>
            <button
              type="button"
              onClick={goToHome} className='foot-button'
            >
              Home
            </button>
          </div>
        </form>
        {/* Display loading message */}
        {loading && <p style={{ textAlign: 'center', marginTop: '20px', color: '#007CA0' , fontSize: '20px' }}>Loading...</p>}
        {/* Render the HtmlInNewWindow component when responseHtml is available */}
        {isSubmitted && responseHtml && <HtmlInNewWindow htmlContent={responseHtml} />} 
      </div>
  );
}

export default SetRecoveryPhone;